import type { SVGProps } from 'react';
const SvgFormatColorText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#format_color_text_svg__a)">
      <path
        fill="currentColor"
        d="M2 20h20v4H2v-4Zm3.49-3h2.42l1.27-3.58h5.65L16.09 17h2.42L13.25 3h-2.5L5.49 17Zm4.42-5.61 2.03-5.79h.12l2.03 5.79H9.91Z"
      />
    </g>
    <defs>
      <clipPath id="format_color_text_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFormatColorText;
